module.exports = __webpack_public_path__ + "static/media/arrow-down.a1cde9ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.svg
// module id = 306
// module chunks = 0